import React from "react";

//Importar íconos de Material UI.
import { Forum } from '@mui/icons-material/';

//Importar imágenes (logos).
import LPChatLogo from "../../../../common/Logo/LPChatLogo";

// UnselectedChat: Componenete que renderiza la vista cuando no se ha seleccionado ningun chat.

const UnselectedChat = () => {

    return (
        <div className="container-unselectedChat">

            {/*--------Contenedor con el icono de Chat animado---------- */}
            <div className="content-mask-unselectedChat__icon" >
                {/*--------Icono de Chat en el color de la paleta-------------- */}
                <Forum sx={{ fontSize: "200px", color: "  var(--color-degraded-by-company)" }} />
            </div>
            <div className="content-mask-unselectedChat__icon--grey">
                {/*--------Icono de Chat en gris------------------------ */}
                <Forum sx={{ fontSize: "200px" }} />
            </div>

            {/*------------Contenedor con el texto de seleccionar un chat */}
            <div className="content-unselectedChat--text">
                <span>Seleccione una conversación para ver el historial del chat</span>
            </div>

            {/*------------Contenedor con el logo de LPChat------*/}
            <div className="content-navigation__logo unselectedchat">
                <LPChatLogo theme={'dark'}/>
            </div>
        </div>

    )
};

export default UnselectedChat;